import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { message } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import { theme } from 'utils/style/theme';
import ExchangeTable from './ExchangeTable';
import { exchangeApis } from 'apis/operation/exchangeApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import GrayBox from 'components/container/GrayBox';
import ToggleButton from 'components/button/ToggleButton';
import TableToolbar from 'components/table/TableToolbar';
import SubmitButton from 'components/button/SubmitButton';
import DefaultInput from 'components/input/DefaultInput';

/**
 *
 * @returns {코인 환전 관리 페이지 - 수정 가능}
 */
const ExchangeUpdatePage = () => {
  const [datas, setDatas] = useState();

  const handleInputNumber = (e) => {
    setDatas(
      datas?.map((v) =>
        v.key === Number(e.target.id)
          ? { ...v, [e.target.name]: Number(e.target.value) }
          : v,
      ),
    );
  };

  /// 판매중 토글 이벤트
  const handleChangeToggle = (e) => {
    setDatas(
      datas?.map((v) =>
        v.key === Number(e.target.name)
          ? { ...v, is_service: e.target.checked ? 1 : 0 }
          : v,
      ),
    );
  };

  /// 전송하기
  const handleSubmit = async () => {
    const res = await exchangeApis.update(datas);
    if (!res) {
      return false;
    }

    fetchData();
    message.success('코인 환전 정보 저장 완료 ', 1);
  };

  const fetchData = async () => {
    const res = await exchangeApis.read();
    // 데이터에 key 값을 추가해준다.
    let newArr = [];
    res?.map((v, i) => newArr.push({ ...v, key: i }));

    setDatas(newArr);
  };
  useEffect(() => {
    fetchData().catch(console.log);
  }, []);

  return (
    <DefaultLayout>
      <TableToolbar>
        <NoticeText>
          <p>※ 스타갯수가 적은 것 부터 입력해주세요. </p>
          <p>※ 일일 구매 횟수가 무제한일 경우, -1 을 입력해주세요.</p>
        </NoticeText>
        <SubmitButton onClick={handleSubmit}>수정</SubmitButton>
      </TableToolbar>
      <GrayBox layout>
        <ExchangeTable>
          <tbody>
            {datas?.map((v, i) => (
              <tr key={v.exchange_product_id}>
                <th className='th_number' style={{ width: '0rem' }}>
                  {v.exchange_product_id}
                </th>

                <th style={{ width: '6rem' }}>기본 환전</th>
                <td style={{ width: '10rem' }}>
                  <DefaultInput
                    type='number'
                    name='star_quantity'
                    id={i}
                    value={v.star_quantity}
                    onChange={handleInputNumber}
                    style={{ width: '10rem' }}
                  />
                  <span>스타</span>
                </td>
                <td
                  className='td_icon'
                  style={{ width: '3rem', textAlign: 'center' }}
                >
                  <CaretRightOutlined
                    style={{ color: theme.colors.blueText, opacity: '0.6' }}
                  />
                </td>
                <td style={{ width: '10rem' }}>
                  <DefaultInput
                    type='number'
                    name='coin_quantity'
                    id={i}
                    value={v.coin_quantity}
                    onChange={handleInputNumber}
                    style={{ width: '10rem' }}
                  />
                  <span>코인</span>
                </td>
                <td className='td_none'></td>
                <th style={{ width: '8rem' }}>보너스 지급</th>
                <td style={{ width: '10rem' }}>
                  <DefaultInput
                    type='number'
                    name='bonus_quantity'
                    id={i}
                    value={v.bonus_quantity}
                    onChange={handleInputNumber}
                    style={{ width: '10rem' }}
                  />
                  <span>코인</span>
                </td>
                <td className='td_none'></td>
                <th style={{ width: '8rem' }}>일일 구매 횟수</th>
                <td style={{ width: '8rem' }}>
                  <DefaultInput
                    type='number'
                    name='daily_purchase_cnt'
                    id={i}
                    value={v.daily_purchase_cnt}
                    onChange={handleInputNumber}
                    style={{ width: '10rem' }}
                  />
                </td>
                <td className='td_none'></td>
                <th style={{ width: '3rem' }}>판매중</th>
                <td style={{ width: '3rem' }}>
                  <ToggleButton
                    name={i}
                    value={v.is_service}
                    onChange={handleChangeToggle}
                    checked={v.is_service === 1 ? true : false}
                  />
                </td>
              </tr>
            ))}
            {/* 현재는 9개가 있기 때문에 불필요 */}
            {/* {datas?.length < 9 && (
              <tr>
                <CircleButton onClick={handleAddInput}>+</CircleButton>
              </tr>
            )} */}
          </tbody>
        </ExchangeTable>
      </GrayBox>
    </DefaultLayout>
  );
};

export default ExchangeUpdatePage;

const NoticeText = styled.div`
  p {
    color: ${theme.colors.redText};
    font-weight: 600;
  }
`;
